export const CASES_PATH = "/werk";
export const UPDATES_PATH = "/updates";
export const EXPERTISES_PATH = "/aanpak";
export const PRODUCTS_PATH = "/products";
export const WERKENBIJ_PATH = "/werken-bij";

export const TRANSITION_DURATION = 200;
